import { useAxios } from "@/hooks/useAxios";
import { BuildingStructure } from "@/store/propertyState";
import { API_BUILDING_DETAIL } from "@/types/endpoint";

interface IUpload {
  address: string;
}

interface IDownload {
  status: string | null;
  message: string | null;
  result: {
    aboveground_floor: number;
    address: {
      postcode: string;
      full: string;
      prefecture: string;
      municipality: string;
      oaza: string;
      chome: string;
      banchi_gou: string;
    };
    built_at: string;
    built_month: number;
    built_year: number;
    name: string;
    name_kana: string;
    structure: string;
    total_units: number;
  };
}

interface IStored {
  name: string;
  aboveground_floor: number;
  addrea_area: string;
  postcode: string;
  addrea_detail: string;
  built_year: number;
  structure: BuildingStructure;
}

function chome2Num(str: string) {
  if (str.indexOf("丁目")) {
    str = str.replace("丁目", "-");
    return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
    });
  }
  return str;
}

function changeStructure(text: string): BuildingStructure {
  switch (text) {
    case "wood":
      return "wood" as BuildingStructure;
    case "RC":
      return "reinforced_concrete" as BuildingStructure;
    case "SRC":
      return "reinforced_concrete" as BuildingStructure;
    case "Steel":
      return "light_weight_steel" as BuildingStructure;
    case "LightSteel":
      return "light_weight_steel" as BuildingStructure;
    default:
      return "" as BuildingStructure;
  }
}

function processing(downloaded: IDownload) {
  const r = downloaded.result;
  const a = r.address;
  const item: IStored = {
    name: r.name,
    aboveground_floor: r.aboveground_floor,
    addrea_area: a.prefecture + a.municipality + a.oaza,
    addrea_detail: chome2Num(a.chome) + a.banchi_gou,
    postcode: String(a.postcode).padStart(7, "0"),
    built_year: r.built_year,
    structure: changeStructure(r.structure),
  };
  return item;
}

export const useBuildingDetail = () => {
  return useAxios<IUpload, IDownload, IStored>(API_BUILDING_DETAIL, processing);
};
